import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { GetSmtpCampaignView } from "../Features/smtpcampaign/Smtpcampaignview";
import { GetSmtpCampaignReport } from "../Features/Smtpcampaignreports/Smtpcampaignreports";
import { UpdateSmsCampaignsStatus } from "../Features/smscampaignlist/smscampaignlist";
import { AddSmtpCampaignsReportsRetry } from "../Features/Smtpcampaignreports/Smtpcampaignreports";
import { RootState, AppDispatch } from "../Appstore/store";
import { formatDate } from "../helper";
import { setIsLoading } from "../Features/loadingSlice";
import { toast } from "sonner";
import { RenderPaginationButtons } from "./Paginations";
import { MdClear } from "react-icons/md";
import { BiExport } from "react-icons/bi";
import { GetallSmtpCampaignReportDawnlaod } from "../Features/Smtpcampaignreports/Smtpcampaignreportdawnload";
import { isJSONString } from "../User/Pages/Chatbox/ChatBox";
import { UpdateSmtpCampaignsStatus } from "../Features/smtpcampaign/Smtpcampaign";

export interface SmtpCampaignView {
  id?: number;
  sms_campaign_id?: number;
  gateway_name?: string;
  message?: string;
  status?: number;
  schedule_time: string;
  retries: number;
  xls_file: string;
  xls_file_name: string;
  numbers_count: number;
  number_to_be_processed: number;
  failed_reason: string;
  createdAt: string;
  updatedAt: string;
  campaign_name: string;
}

export interface SmsCampaignListRecord {
  id?: number;
  receiver_email: string;
  status?: number;
  createdAt: string;
  sms_gateway: {
    name: string;
    id?: number;
    gateway_id?: number;
  };
  sms_gateways_number: {
    gateway_number: string;
  };
  length: number;
}

const STATUS = {
  PENDING: 1,
  RUNNING: 2,
  STOPPED: 3,
  COMPLETED: 4,
  CANCELED: 5,
  FAILED: 6,
};

function Viewsmtpcampaign() {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit, setLimit] = useState(10);
  const [isExporting, setIsExporting] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id }: any = useParams();

  const [gatewayName, setGatewayName] = useState("");
  const [gatewayEmail, setGatewayEmail] = useState("");
  const [receiverEmail, setReceiverEmail] = useState("");
  const [status, setStatus] = useState("");
  const [retryStatus, setretryStatus] = useState("");
  const [attempt, setAttempt] = useState("");

  const { smtpcampaignviewsdata } = useSelector(
    (state: RootState) => state.smtpcampaignview
  );
  const record: SmtpCampaignView | any = smtpcampaignviewsdata[0];

  const { smtpcampaignreportdata, loading, info, error } = useSelector(
    (state: RootState) => state.smtpcampaignreports
  );
  const recordreport: SmsCampaignListRecord | any =
    smtpcampaignreportdata || [];

  useEffect(() => {
    if (id) {
      dispatch(setIsLoading(true));
      dispatch(GetSmtpCampaignView(id))
        .unwrap()
        .catch((err) => {
          console.error("Error fetching sms campaign list view:", err);
        })
        .finally(() => {
          setTimeout(() => dispatch(setIsLoading(false)), 500);
        });
    }
  }, [id, dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(
        GetSmtpCampaignReport({
          id: id,
          smtp_gateway_name: gatewayName,
          smtp_gatewayemail: gatewayEmail,
          receiver_email: receiverEmail,
          status: status ? parseInt(status, 10) : undefined,
          retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
          attempt: attempt ? parseInt(attempt, 10) : undefined,
          limit: limit,
          page: currentPage,
        })
      );
      setIsLoading(true);
    }, 0);

    return () => clearTimeout(timer);
  }, [dispatch, currentPage, limit, id]);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(
        GetSmtpCampaignReport({
          id: id,
          smtp_gateway_name: gatewayName,
          smtp_gatewayemail: gatewayEmail,
          receiver_email: receiverEmail,
          status: status ? parseInt(status, 10) : undefined,
          retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
          attempt: attempt ? parseInt(attempt, 10) : undefined,
          limit: limit,
          page: currentPage,
        })
      );
      setIsLoading(true);
    }, 500);

    return () => clearTimeout(timer);
  }, [
    dispatch,
    gatewayName,
    gatewayEmail,
    receiverEmail,
    status,
    retryStatus,
    attempt,
  ]);

  const handleDownload = () => {
    setIsExporting(true);
    dispatch(
      GetallSmtpCampaignReportDawnlaod({
        id: id,
        smtp_gateway_name: gatewayName,
        smtp_gatewayemail: gatewayEmail,
        receiver_email: receiverEmail,
        status: status ? parseInt(status, 10) : undefined,
        retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
        attempt: attempt ? parseInt(attempt, 10) : undefined,
        limit: limit,
        page: currentPage,
      })
    )
      .then((response) => {
        if (
          response.meta.requestStatus === "fulfilled" &&
          response.payload instanceof Blob
        ) {
          const blob = response.payload;

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Smtp-Campaign-Report_${new Date().toISOString()}.xlsx`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .finally(() => {
        setTimeout(() => {
          setIsExporting(false);
        }, 500);
      });
  };

  const navigatetobackpage = () => {
    navigate(-1);
  };

  const handlestatus = (newStatus: number) => {
    dispatch(UpdateSmtpCampaignsStatus({ id, status: newStatus }))
      .unwrap()
      .then((resp) => {
        if(resp?.message) toast.success(resp?.message);
        dispatch(GetSmtpCampaignView(id))
        .unwrap()
        .catch((err) => {
          console.error("Error fetching sms campaign list view:", err);
        })
        .finally(() => {
          setTimeout(() => dispatch(setIsLoading(false)), 500);
        });
      })
      .catch((err) => {
        if(err?.message) toast.success(err?.message);
        console.error("Error updating campaign status:", err?.message);
      });
  };

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= (info?.total_page || 1)) {
      setCurrentPage(page);
    }
  };

  const handleRetry = async (retrydata: any) => {
    const resp: any = await dispatch(AddSmtpCampaignsReportsRetry(retrydata));
    dispatch(setIsLoading(true));
    if (resp?.payload?.status === "success")
      toast.success(resp?.payload?.message || "");
    else toast.error(resp?.payload?.message || "");
    setTimeout(() => {
      dispatch(setIsLoading(false));
    }, 500);
    dispatch(
      GetSmtpCampaignReport({
        id: id,
        smtp_gateway_name: gatewayName,
        smtp_gatewayemail: gatewayEmail,
        receiver_email: receiverEmail,
        status: status ? parseInt(status, 10) : undefined,
        retry_status: retryStatus ? parseInt(retryStatus, 10) : undefined,
        attempt: attempt ? parseInt(attempt, 10) : undefined,
        limit: limit,
        page: currentPage,
      })
    );
  };

  const handleClearSearchFilter = () => {
    setGatewayName("");
    setGatewayEmail("");
    setReceiverEmail("");
    setStatus("");
    setretryStatus("");
    setAttempt("");
    setCurrentPage(1);
  };

  if (error) {
    <div>No found data</div>;
  }

  return (
    <>
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content">
            <div className="container-fluid">
              <div className="card mt-4 shadow-sm border rounded">
                <div className="card-header bg-white p-3 d-flex justify-content-md-between">
                  <h2 className="w-100 mb-md-0 fs-3">View SMTP Campaigns</h2>
                  <div className="d-flex align-items-center ">
                    <button
                      onClick={() => handlestatus(3)}
                      className={`btn btn-warning me-2 ${record?.status === 1 ? "d-block disabled" : "d-none"
                        }`}
                    >
                      Pending
                    </button>
                    <button
                      onClick={() => handlestatus(2)}
                      className={`btn btn-success me-2 ${record?.status === 3 ? "d-block" : "d-none"
                        }`}
                    >
                      Start
                    </button>
                    <button
                      onClick={() => handlestatus(3)}
                      className={`btn btn-danger me-2 ${record?.status === 2 ? "d-block" : "d-none"
                        }`}
                    >
                      Stop
                    </button>
                    <button
                      onClick={() => handlestatus(3)}
                      className={`btn btn-danger me-2 ${record?.status === 2 ||
                        record?.status === 3 ||
                        record?.status === 5
                        ? "d-block"
                        : "d-none"
                        }`}
                    >
                      Canceled
                    </button>
                    <button
                      onClick={() => handlestatus(3)}
                      className={`btn btn-success me-2 ${record?.status === 4 ? "d-block disabled" : "d-none"
                        }`}
                    >
                      Completed
                    </button>
                    <button
                      onClick={() => handlestatus(3)}
                      className={`btn btn-danger me-2 ${record?.status === 6 ? "d-block disabled" : "d-none"
                        }`}
                    >
                      Failed
                    </button>
                    <button
                      style={{ minWidth: 150 }}
                      className={`btn btn-warning fw-bold me-2 ${record?.status === 7 || record?.status === 8
                        ? "d-block disabled"
                        : "d-none"
                        }`}
                    >
                      {record?.status === 7
                        ? "Retry Pending"
                        : record?.status === 8
                          ? "Retry Running"
                          : ""}
                    </button>

                    <Link to={""} className="text-decoration-none">
                      <button
                        onClick={navigatetobackpage}
                        className="btn btn-info text-white d-flex align-items-center fw-semibold"
                      >
                        <IoMdArrowRoundBack /> Back
                      </button>
                    </Link>
                  </div>
                </div>

                <div className="card-body px-0 py-0">
                  <div className="table-responsive">
                    <table className="table mb-0 table-bordered">
                      <tbody>
                        {!record || record.length === 0 ? (
                          <tr>
                            <td colSpan={7} height={50}>
                              <div className="text-center">
                                <p className="mb-0 fs-5 fw-semibold">
                                  No data found
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                SMTP Campaign Name
                              </th>
                              <td className="p-3">{record?.name || "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                SMTP Gateway Name
                              </th>
                              <td className="p-3">
                                {record?.smtp_gateway?.gateway_name || "-"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Subject
                              </th>
                              <td className="p-3">{record?.subject || "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                CC
                              </th>
                              <td className="p-3">{record?.cc || "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                BCC
                              </th>
                              <td className="p-3">{record?.bcc || "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Reply To
                              </th>
                              <td className="p-3">{record?.reply_to || "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Message
                              </th>
                              <td className="p-3">{record?.message ? <div>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: record?.message.replace(
                                      /<img /g,
                                      '<img style="width:100% !important; max-width:650px !important; height:auto !important; object-fit:contain !important;" '
                                    )
                                  }}
                                />
                              </div> : "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Attachments
                              </th>
                              <td className="p-3">{isJSONString(record?.attachments || "[]") ?
                                <div className="d-flex gap-3 flex-wrap">
                                  {JSON.parse(record?.attachments || "[]").map((item: any, i: number) => (
                                    <div className="px-3 p-1 bg-light rounded-3 d-flex flex-column" style={{ width: "fit-content" }}>
                                      <span><b>Filename :</b> {item?.filename}</span>
                                      <span><b>File Url :</b> {item?.path}</span>
                                    </div>
                                  ))}
                                </div>
                                : "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Status
                              </th>
                              <td className="p-3">
                                {record?.status === STATUS.PENDING
                                  ? "Pending"
                                  : record?.status === STATUS.RUNNING
                                    ? "Running"
                                    : record?.status === STATUS.STOPPED
                                      ? "Stopped"
                                      : record?.status === STATUS.COMPLETED
                                        ? "Completed"
                                        : record?.status === STATUS.CANCELED
                                          ? "Canceled"
                                          : record?.status === 7
                                            ? "Retry Pending"
                                            : record?.status === STATUS.CANCELED
                                              ? "Retry Running"
                                              : "Failed"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Schedule Time
                              </th>
                              <td className="p-3">
                                {formatDate(record?.schedule_time) || "-"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Retries
                              </th>
                              <td className="p-3">{record?.retries || "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Retry Minutes
                              </th>
                              <td className="p-3">
                                {record?.retry_minutes || "-"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Xls-File
                              </th>
                              <td className="p-3">{record?.xls_file || "-"}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Emails Count
                              </th>
                              <td className="p-3">
                                {record?.emails_count || "-"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Failed Reasons
                              </th>
                              <td className="p-3">
                                {record?.failed_reason || "-"}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Created At
                              </th>
                              <td className="p-3">
                                {formatDate(record?.createdAt)}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Updated At
                              </th>
                              <td className="p-3">
                                {formatDate(record?.updatedAt)}
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>

                    <div className="card mt-4 rounded-0 d-flex border-start-0 border-end-0">
                      <div className="card-header bg-white p-3 pt-4 d-flex flex-wrap gap-2">
                        <h2 className="mb-0 fs-4 flex-grow-1">
                          Emails To be Processed
                        </h2>
                        <div className="d-flex gap-2">
                          <button
                            onClick={handleDownload}
                            className="btn btn-success"
                            disabled={isExporting}
                            style={{ minWidth: 125 }}
                          >
                            <BiExport className="fs-5 me-2" />
                            {isExporting ? "Exporting..." : `Export `}
                          </button>
                          <button
                            onClick={handleClearSearchFilter}
                            className="btn btn-secondary"
                            style={{ minWidth: 125 }}
                          >
                            <MdClear className="fs-5" />
                            Clear Filter
                          </button>
                        </div>
                      </div>
                      <div className="card-body border-start-0 border-end-0 p-0">
                        <>
                          <div className="table-responsive">
                            <table className="table table-hover table-bordered text-nowrap">
                              <thead>
                                <tr>
                                  <th className="ps-3 sr-no">SR No</th>
                                  <th>Smtp Gateway Name</th>
                                  <th>From Email</th>
                                  <th>To Email</th>
                                  <th
                                    className=" text-center"
                                    style={{ minWidth: 151 }}
                                  >
                                    Status
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ width: 151 }}
                                  >
                                    Attempt
                                  </th>
                                  <th
                                    className="text-center createdat"
                                    style={{ minWidth: 151 }}
                                  >
                                    Retry Status
                                  </th>
                                  <th
                                    className="createdat text-center"
                                    style={{ minWidth: 170 }}
                                  >
                                    Retry At
                                  </th>
                                  <th
                                    className="text-center"
                                    style={{ minWidth: 130 }}
                                  >
                                    Retry Error Code
                                  </th>
                                  <th className="">Retry Error Message</th>
                                  <th
                                    className="text-center"
                                    style={{ minWidth: 130 }}
                                  >
                                    Error Code
                                  </th>
                                  <th className="">Error Message</th>
                                  <th className="text-center createdat">
                                    CreatedAt
                                  </th>
                                  <th
                                    className="action text-center"
                                    style={{ minWidth: 200 }}
                                  >
                                    Actions
                                  </th>
                                </tr>
                                <tr>
                                  <th className="ps-3"></th>
                                  <th>
                                    <input
                                      type="text"
                                      placeholder="Search Gateway Name"
                                      onChange={(e) =>
                                        setGatewayName(e.target.value.trim())
                                      }
                                      className="form-control"
                                      value={gatewayName}
                                    />
                                  </th>
                                  <th>
                                    <input
                                      type="text"
                                      placeholder="Search Gateway Email"
                                      onChange={(e) =>
                                        setGatewayEmail(e.target.value.trim())
                                      }
                                      className="form-control"
                                      value={gatewayEmail}
                                    />
                                  </th>
                                  <th>
                                    <input
                                      type="text"
                                      placeholder="Search Receiver Email"
                                      onChange={(e) =>
                                        setReceiverEmail(e.target.value.trim())
                                      }
                                      className="form-control"
                                      value={receiverEmail}
                                    />
                                  </th>
                                  <th>
                                    <select
                                      onChange={(e) =>
                                        setStatus(e.target.value.trim())
                                      }
                                      className="form-control"
                                      value={status}
                                    >
                                      <option value="">All Status</option>
                                      <option value="0">Failed</option>
                                      <option value="1">Success</option>
                                    </select>
                                  </th>
                                  <th>
                                    <input
                                      type="text"
                                      placeholder="Search Attempt"
                                      onChange={(e) =>
                                        setAttempt(e.target.value.trim())
                                      }
                                      className="form-control"
                                      value={attempt}
                                    />
                                  </th>
                                  <th>
                                    <select
                                      onChange={(e) =>
                                        setretryStatus(e.target.value.trim())
                                      }
                                      className="form-control"
                                      value={retryStatus}
                                    >
                                      <option value="">All Status</option>
                                      <option value="0">Failed</option>
                                      <option value="1">Success</option>
                                    </select>
                                  </th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                </tr>
                              </thead>

                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={14} height={100}>
                                      <div className="text-center">
                                        <div className="loader"></div>
                                      </div>
                                    </td>
                                  </tr>
                                ) : !recordreport ||
                                  recordreport.length === 0 ? (
                                  <tr>
                                    <td colSpan={14} height={50}>
                                      <div className="text-center">
                                        <p className="mb-0 fs-5 fw-semibold">
                                          No data found
                                        </p>
                                      </div>
                                    </td>
                                  </tr>
                                ) : error?.length === 0 ? (
                                  <tr>
                                    <td colSpan={14} height={50}>
                                      <div className="text-center">
                                        <p className="mb-0 fs-5 fw-semibold">
                                          No data found
                                        </p>
                                      </div>
                                    </td>
                                  </tr>
                                ) : (
                                  recordreport.map(
                                    (item: any, index: number) => (
                                      <tr key={item.id}>
                                        <td className="ps-3">
                                          {(currentPage - 1) * limit +
                                            index +
                                            1}
                                        </td>
                                        <td>
                                          {item.smtp_gateway?.gateway_name ||
                                            "-"}
                                        </td>
                                        <td>
                                          {item.smtp_gateway?.from_email || "-"}
                                        </td>
                                        <td>{item.receiver_email}</td>

                                        <td
                                          className={`text-center ${item?.status === 0
                                            ? "text-danger fw-bold"
                                            : item?.status === 1
                                              ? "text-success fw-bold"
                                              : "text-muted"
                                            }`}
                                        >
                                          {item.status === 0
                                            ? "Failed"
                                            : item.status === 1
                                              ? "Success"
                                              : " - "}
                                        </td>

                                        <td className="text-center">
                                          {item.attempt || "-"}
                                        </td>

                                        <td
                                          className={`text-center ${item?.retry_status === 0
                                            ? "text-danger fw-bold"
                                            : item?.retry_status === 1
                                              ? "text-success fw-bold"
                                              : "text-muted"
                                            }`}
                                        >
                                          {item.retry_status === 0
                                            ? "Failed"
                                            : item.retry_status === 1
                                              ? "Success"
                                              : " - "}
                                        </td>

                                        <td className="text-center">
                                          {formatDate(item.retry_at) || "-"}
                                        </td>
                                        <td className="text-center">
                                          {item.retry_error_code || "-"}
                                        </td>
                                        <td className="text-center">
                                          {item.retry_error_message || "-"}
                                        </td>
                                        <td className="text-center">
                                          {item.error_code || "-"}
                                        </td>
                                        <td className="text-center">
                                          {item?.error_message|| "-"}
                                        </td>
                                        <td className="text-center">
                                          {formatDate(item.createdAt) || "-"}
                                        </td>
                                        <td className="text-center">
                                          {[0].includes(item.status) &&
                                            ![1].includes(
                                              item?.retry_status || 0
                                            ) ? (
                                            <i
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                handleRetry({
                                                  id: item?.id,
                                                  smtp_campaign_id: Number(id),
                                                })
                                              }
                                              className="fa-solid fa-rotate-right ms-1 bg-transparent border-0 text-success fs-5"
                                            ></i>
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>

                          {!recordreport || recordreport.length === 0 ? (
                            <div></div>
                          ) : (
                            <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                              <RenderPaginationButtons
                                info={info}
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                              />
                            </div>
                          )}
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default Viewsmtpcampaign;
